import { UUID } from "../generic/uuid";
import { WineryDto } from "@vini-wine/core-dtos";

export interface WineryModel extends UUID {
  // available includes
  mappedItems?: any;

  // transform
  name: string;
}

export const createWineryDtoFromAdminWineryModel = (
  winery: WineryModel,
): WineryDto => {
  return {
    uuid: winery.uuid,
    name: winery.name,
  };
};
